import React, { useEffect, useMemo, useState } from 'react';
import { Skeleton, Tooltip } from '@mui/material';
import { SortAscAlphabeticalIcon, SortDescAlphabeticalIcon } from 'ui-component/custom-icons/icons';
import { PiMicrosoftExcelLogoFill } from 'react-icons/pi';
import StatusBadge from '../../../../../ui-component/StatusBadge';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';

// ✅ Clear
const InvoicesStatsComponent = ({ details, isLoading }) => {
	
	const [sortOrder, setSortOrder] = useState('desc');
	const [isLoadingData, setIsLoadingData] = useState(true);

	const sortedData = useMemo(() => {
		if (!details) return [];


		return [...details].sort((a, b) => {
			const nameA = a.name || '';
			const nameB = b.name || '';
			if (sortOrder === 'asc') {
				return nameA.localeCompare(nameB);
			} else {
				return nameB.localeCompare(nameA);
			}
		});
	}, [details, sortOrder]); // sortBy is removed as it's constant

	const s2ab = (s) => {
		const buf = new ArrayBuffer(s.length);
		const view = new Uint8Array(buf);
		for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
		return buf;
	};

	const download = () => {
		const wb = XLSX.utils.book_new();
		// Create a worksheet
		const ws = XLSX.utils.json_to_sheet(details);
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

		// Convert the workbook to a binary string
		const wbBinaryString = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

		// Convert the binary string to a Blob
		const blob = new Blob([s2ab(wbBinaryString)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

		saveAs(blob, `Contact Details Invoices.xlsx`);
	}

	useEffect(() => {
		setIsLoadingData(isLoading);
	}, [isLoading]);

	return (
		<div className="card" style={{ height: '250px' }}>
			<div className="card-body" style={{ padding: '15px', zIndex: '1' }}>
				<div className="flex justify-content-between">
					<div className="text-lg fw-500">
						Invoices Stats
					</div>
					<div className="flex gap-1 absolute" style={{ right: '20px', top: '6px' }}>
						{
							isLoading ? (
								<div style={{ width: '100px', marginTop: '8px' }}>
									<Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
								</div>
							) : (
								<>
									<div
										className="widget-action-icon-container"
										onClick={() => download()}
									>
										<Tooltip title="Export" arrow placement="top">
											<div className="text-black cursor-pointer">
												<PiMicrosoftExcelLogoFill style={{ fontSize: '1.4em' }} />
											</div>
										</Tooltip>
									</div>
									{/* Sort by Name is now the only sort option */}
									<div
										className={`widget-action-icon-container-2 active`}
										onClick={() => {
											// setSortBy is no longer needed
											setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
										}}
									>
										<Tooltip title="Sort by Name" arrow placement="top">
											<div className="widget-action-icon cursor-pointer">
												{sortOrder === 'asc' ? (
													<SortAscAlphabeticalIcon height='15px' width='15px' />
												) : (
													<SortDescAlphabeticalIcon height='15px' width='15px' />
												)}
											</div>
										</Tooltip>
									</div>
								</>
							)
						}
					</div>
				</div>
				<div className="overflow-y-auto custom-scrollbar " style={{ maxHeight: '185px', margin: '10px 0' }}>
					{
						!isLoadingData ? (
							sortedData?.length > 0 ? (
								sortedData.map((item, index) => (
									<Link
										to={`/sales/invoices/${item?.id}?ref=${item?.ref || ''}`}
										style={{ textDecoration: 'none', color: 'inherit' }}
										className="text-inherit hover:underline"
									>
										<div key={index} className="w-full flex justify-between items-center gap-2 dashboard-country-list" style={{ padding: '4px 4px' }}>
											<div className="font-normal flex-grow min-w-0 truncate">
												{item?.name}
											</div>
											<div className="flex-shrink-0" style={{ width: '90px' }}>
												<StatusBadge itemStatus={item.status} />
											</div>
										</div>
									</Link>
								))
							) : (
								<div className="row" style={{ padding: '5px 0' }}>
									<div className="col-12 text-gray-500">
										No data found
									</div>
								</div>
							)
						) : (
							[...Array(15)].map((e, i) => (
								<div key={i} className="row" style={{ padding: '5px 0' }}>
									<div className="col-12">
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
									</div>
								</div>
							))
						)
					}
				</div>
			</div>
		</div>
	)
}


export default InvoicesStatsComponent;